<template>
    <div class="hydroxid-ionen">
        <p>
            Universalindikator Blau
            <br />
            OH<sup>-</sup>
        </p>
    </div>
</template>

<script>
export default {
    name: 'hydroxid-ionen',
};
</script>
